<template>
  <div>
    <div class="owl">
      <router-link :to="albumPages(album)" class="button">
        <i class="fa fa-chevron-circle-left"></i>
        Back to Organize pages
      </router-link>
      <router-link :class="{ disabled: !previousPageRoute }" :to="previousPageRoute" class="button">Previous Page</router-link>
      <router-link :class="{ disabled: !nextPageRoute }" :to="nextPageRoute" class="button">Next Page</router-link>
      <span v-if="loading"><i class="fas fa-spinner fa-spin"></i></span>
    </div>
    <div>
      <div v-if="loadingError">There was an error: {{loadingError.message}}</div>
      <div v-if="page">
        <div v-if="isEditing">
          <PageEdit
            :page="page"
            :links="links"
            :createLink="createLink"
            :updateLink="updateLink"
            :deleteLink="deleteLink"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import PageEdit from './PageEdit'
import { albumPages, editPage } from '../utils/routing'

export default {
  props: {
    album: Object,
    id: [Number, String],
    route: Object,
  },
  data() {
    return {
      ...this.getShowHideData(this.route),
      page: null,
      links: null,
      loading: false,
      loadingError: null,
    }
  },
  mounted() {
    this.fetchPageData()
  },
  computed: {
    previousPageRoute() {
      const currentPageIdAsNum = parseInt(this.id)
      const currentPageIndex = this.album.pageOrders.findIndex(x => x === currentPageIdAsNum)
      if (currentPageIndex === 0) {
        return ''
      }
      const pageId = this.album.pageOrders[currentPageIndex - 1]
      return editPage(this.album, pageId)
    },
    nextPageRoute() {
      const currentPageIdAsNum = parseInt(this.id)
      const currentPageIndex = this.album.pageOrders.findIndex(x => x === currentPageIdAsNum)
      if (currentPageIndex === this.album.pageOrders.length - 1) {
        return ''
      }
      const pageId = this.album.pageOrders[currentPageIndex + 1]
      return editPage(this.album, pageId)
    },
  },
  methods: {
    fetchPageData() {
      if (!this.id) {
        return
      }
      this.loading = true
      axios.get('/api/pages/' + this.id).then(response => {
        this.page = response.data.page
        this.links = response.data.links
      }).catch(error => {
        this.loadingError = error.response ? error.response.data : error
      }).finally(() => {
        this.loading = false
      })
    },
    getShowHideData(route) {
      return {
        isEditing: route.name === 'pageEdit',
      }
    },
    createLink(data) {
      this.loading = true
      const pageId = this.id
      return axios.post(`/api/pages/${pageId}/links`, data)
        .catch(error => {
          this.loadingError = error.response ? error.response.data : error
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateLink(data) {
      this.loading = true
      return axios.patch(`/api/links/${data.id}`, data)
        .catch(error => {
          this.loadingError = error.response ? error.response.data : error
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteLink(link) {
      this.loading = true
      return axios.delete(`/api/links/${link.id}`)
        .catch(error => {
          this.loadingError = error.response ? error.response.data : error
        })
        .finally(() => {
          this.loading = false
        })
    },
    albumPages,
  },
  watch: {
    route(newRoute) {
      Object.assign(this.$data, this.getShowHideData(newRoute))
    },
    id() {
      this.page = null
      this.fetchPageData()
    }
  },
  components: {
    PageEdit,
  },
}
</script>
